var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"A1"},[_c('Header'),_vm._v(" "),_c('Banner'),_vm._v(" "),_c('NavSecond'),_vm._v(" "),_c('Breadcrumb'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.content)}})])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1d910c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Serve/A3/A3.vue
// module id = null
// module chunks = 